import Vue from 'vue';
import { beforeRouteEnter } from '@assets/js/routerPageHook.js';
import formSteps from "@components/base/form-steps.vue";
import formGreen from "@components/base/form-green.vue";
import { mapGetters, mapState } from "vuex";
import {router} from "@src/routes";

export default {
    name: 'index',
    data() {
        return {
            template: '<main></main>',
            error: false
        }
    },
    components: {
        'form-steps-cmp': formSteps,
        'form-green-cmp': formGreen
    },
    computed: {
        ...mapGetters('lk', ['isAuth', 'linkAuth']),
        ...mapState('mobile', ['isMobile']),
    },
    methods: {
        errorData(data) {
            this.error = data.error;
        },
        scrollToForm(from) {
            // если перешли со страницы акций лк
            if (from === 'lk-promotions') {
                setTimeout(() => {
                    this.$root.scrollToBlock('.js-reg-form');
                }, 1500);
            }
        },
    },
    beforeRouteUpdate(to, from, next) {
        const path = to.path.replace(router.history.base, '');
        Vue.http.get(`templates${path}`, { params: to.query }).then(
            (data) => {
                next();
                this.template = data.data;
            },
            () => {
                next('/404');
            }
        );
    },
    beforeRouteEnter,
    render(createElement) {
        return Vue.compile(this.template).render.call(this, createElement);
    },
};


// WEBPACK FOOTER //
// ./src/templates/pages/promotions/view/index.js